import scopedRecordSchema from "./scopedRecordSchema";

const templateSchema = function(state, props) {
  const kind = state.entities.template.byId[props.entityId].kind

  const letterMentionOptions =  ["patient_first_name", "patient_last_name", "consultation_dates", "consultation_dates_and_hours", "first_consult_date", "latest_consult_date", "signature"]
  const letterMentionExamples =  ["Sigmund", "Freud", "16-10-2023\n26-10-2023\n3-11-2023\n10-11-2023", "16-10-2023 om 13u\n26-10-2023 om 15u30\n3-11-2023 om 13u\n10-11-2023 om 14u", "16-10-2023", "10-11-2023", "[JOUW HANDTEKENING]"]

  const mentionOptions = kind === "letter" ? letterMentionOptions : null
  const mentionExamples = kind === 'letter' ? letterMentionExamples : null

  const uiSchema = {
    "ui:readonly": props.readonly,
    "subject": {
      "ui:autofocus": true,
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:options": {
        width: 6
      }
    },
    "body": {
      "ui:widget": "HtmlWidget",
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:options": {
        width:12,
        mentionOptions: mentionOptions,
        mentionExamples: mentionExamples,
        textWillBeUsedInPdf: true
      },
    },
    "officeId": {
      "ui:widget": "hidden"
    },
    "kind": {
      "ui:widget": "hidden"
    },
    ...scopedRecordSchema(state,props)
  }

return uiSchema
}

export default templateSchema;

